import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/favicon.ico";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const links = [
    ["Flache Geothermie", "/flache-geothermie"],
    ["Kosten", "/erdwaermepumpe-kosten"],
    ["Bundesländer", "/bundeslaender"],
    ["GeoReport", "/report"],
    ["FAQ", "/faq"],
    ["Impressum", "/impressum"],
    ["Datenschutz", "/datenschutz"],
    ["AGB", "/agb"],
    ["Haftung & Nutzung", "/haftung"],
    ["Kontakt", "/contact"],
  ];
  return (
    <footer style={{ background: "#f8f8f8", borderTop: "2px solid #eee", padding: "2rem 1.5rem", color: "#444", fontFamily: "'Inter', Arial, sans-serif" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto", display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: "1rem" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
          <img src={logo} alt="Erdwärme-Experten" style={{ height: "36px" }} />
          <span style={{ fontWeight: 600, fontSize: "1.1rem", color: "#222" }}>Erdwärme-Experten</span>
        </div>
        <nav aria-label="Weitere Seiten" style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
          {links.map(([label, path]) => <Link key={path} to={path} style={linkStyle}>{label}</Link>)}
        </nav>
        <div style={{ color: "#777", fontSize: "0.9rem", flexBasis: "100%", textAlign: "center", marginTop: "1rem" }}>
          © {currentYear} Dr.-Ing. Eike Radeisen · Erdwärme-Experten (Einzelunternehmen) · Alle Rechte vorbehalten
        </div>
      </div>
    </footer>
  );
}
const linkStyle = { textDecoration: "none", color: "#444", fontWeight: 500, transition: "color 0.2s ease" };
